import React from 'react';
import { TextField, Grid, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';

const FEEDBACK_REASONS = [
  'High Cost', 'No Insurance Available', 'Average Care', 'Fear or Anxiety',
  'Postponement Due to Recovery Concerns', 'Lack of Support',
  'Alternative Treatments', 'Uncertainty or Lack of Information',
  'Health-Related Concerns', 'Scheduling or Personal Issues', 'Others',
];

/**
 * Shared Feedback form fields.
 */
const FeedbackForm = ({ formData, handleChange, handlePhoneChange, patients, DOCTOR_LIST }) => (
  <Grid container spacing={2}>
    <Grid item xs={12} sm={6}>
      <TextField select label={<span>UHID No <span style={{ color: 'red' }}>*</span></span>} name="uhid_no" value={formData.uhid_no} onChange={handleChange} fullWidth>
        {(patients || []).map(p => <MenuItem key={p.uhid_no} value={p.uhid_no}>{p.uhid_no} — {p.name}</MenuItem>)}
      </TextField>
    </Grid>
    <Grid item xs={12} sm={6}>
      <PhoneInput country="in" value={formData.mobile_no} onChange={handlePhoneChange} inputProps={{ name: 'mobile_no' }} containerStyle={{ width: '100%' }} inputStyle={{ width: '100%', height: '56px' }} buttonStyle={{ height: '56px' }} />
    </Grid>
    <Grid item xs={12} sm={6}>
      <TextField label={<span>Feedback Date <span style={{ color: 'red' }}>*</span></span>} name="feedback_date" type="date" inputProps={{ min: new Date().toISOString().split('T')[0] }} value={formData.feedback_date} onChange={handleChange} fullWidth InputLabelProps={{ shrink: true }} />
    </Grid>
    <Grid item xs={12} sm={6}>
      <FormControl fullWidth>
        <InputLabel>Doctor Name <span style={{ color: 'red' }}>*</span></InputLabel>
        <Select name="doctor_name" value={formData.doctor_name} onChange={handleChange} label="Doctor Name *">
          {(DOCTOR_LIST || []).map(doc => <MenuItem key={doc.id} value={doc.name}>{doc.name}</MenuItem>)}
        </Select>
      </FormControl>
    </Grid>
    <Grid item xs={12}>
      <FormControl fullWidth>
        <InputLabel>Reason for Quitting Surgery <span style={{ color: 'red' }}>*</span></InputLabel>
        <Select name="feedback_reason" value={formData.feedback_reason} onChange={handleChange} label="Reason for Quitting Surgery *">
          {FEEDBACK_REASONS.map(r => <MenuItem key={r} value={r}>{r}</MenuItem>)}
        </Select>
      </FormControl>
    </Grid>
    {formData.feedback_reason === 'Others' && (
      <Grid item xs={12}>
        <TextField label={<span>Please specify <span style={{ color: 'red' }}>*</span></span>} name="other_reason" value={formData.other_reason} onChange={handleChange} fullWidth multiline rows={4} />
      </Grid>
    )}
  </Grid>
);

export default FeedbackForm;
